import { humanizeTimeFromHours } from '@/utils'
import {
  Asterisk,
  CalendarRange,
  FileLock2,
  MousePointerBan,
  Pause,
  ShieldCheck,
} from 'lucide-react'
import ToggleGroupWithCustom from '../../components/toggle-group-with-custom'

export const VOTING_DELAY = {
  title: 'Voting Delay',
  icon: <Pause size={14} strokeWidth={1.5} />,
  options: [1, 12, 24, 48],
  optionsFormatter: (option: number) => humanizeTimeFromHours(option),
  customLabel: 'hours',
  customPlaceholder: 'Enter custom length',
}

export const VOTING_PERIOD = {
  title: 'Voting Period',
  icon: <CalendarRange size={14} strokeWidth={1.5} />,
  options: [1, 24, 48, 72],
  optionsFormatter: (option: number) => humanizeTimeFromHours(option),
  customLabel: 'hours',
  customPlaceholder: 'Enter custom length',
}

export const VOTING_THRESHOLD = {
  title: 'Proposal Threshold',
  icon: <FileLock2 size={14} strokeWidth={1.5} />,
  options: [0.01, 0.1, 1, 10],
  optionsFormatter: (option: number) => `${option.toString()}%`,
  customLabel: '%',
  customPlaceholder: 'Enter custom',
  description:
    'The minimum percentage of governance power needed in order to initiate a proposal.',
}

export const VOTING_QUORUM = {
  title: 'Voting Quorum',
  icon: <ShieldCheck size={14} strokeWidth={1.5} />,
  options: [10, 15, 20, 25],
  optionsFormatter: (option: number) => `${option.toString()}%`,
  customLabel: '%',
  customPlaceholder: 'Enter custom',
  description: (
    <span>
      The minimum percentage of votes that must be cast as{' '}
      <span className="font-bold">yes</span> or{' '}
      <span className="font-bold">abstain</span> in order for the proposal to be
      eligible to pass (<span className="font-bold">yes</span> votes still must
      outnumber <span className="font-bold">no</span> votes in order to pass the
      proposal).
    </span>
  ),
}

export const VOTING_EXECUTION_DELAY = {
  title: 'Execution Delay',
  icon: <MousePointerBan size={14} strokeWidth={1.5} />,
  options: [0.25, 24, 36, 48],
  optionsFormatter: (option: number) => humanizeTimeFromHours(option),
  customLabel: 'hours',
  customPlaceholder: 'Enter custom length',
}

const FORM = [
  {
    ...VOTING_DELAY,
    description:
      'The time between a basket change proposal being submitted and when governors can cast their votes.',
    fieldName: 'basketVotingDelay',
  },
  {
    ...VOTING_PERIOD,
    description:
      'How long governors have to cast their votes on a basket change after the voting delay.',
    fieldName: 'basketVotingPeriod',
  },
  {
    ...VOTING_THRESHOLD,
    fieldName: 'basketVotingThreshold',
  },
  {
    ...VOTING_QUORUM,
    fieldName: 'basketVotingQuorum',
  },
  {
    ...VOTING_EXECUTION_DELAY,
    description:
      'The time period between when a basket change proposal is considered successful and when the auction can be formally approved.',
    fieldName: 'basketExecutionDelay',
  },
]

const BasketChangesForm = () => {
  return (
    <div className="px-2 mb-2">
      <div className="flex flex-col gap-2">
        {FORM.map((form) => (
          <ToggleGroupWithCustom key={`${form.fieldName}`} {...form} />
        ))}
      </div>
    </div>
  )
}

export default BasketChangesForm
